import apiClient from './api_client_requests';

export default async (payload) => {
    let result = await apiClient.apiMethod({
        method: 'ValidateTicket',
        args: {
            ...payload,
        },
    });

    if (result.entry) {
        return {
            entry: result.entry,
            gameUrl: result.gameUrl,
            // jackpot_entry is an optional return value
            // when a ticket is a jackpot entry
            jackpot_entry: result.jackpot_entry,
            success: true,
            message: "Your entry has been accepted and added to your 'My Entries' page.",
        };
    } else if (result.response) {
        return {
            success: false,
            message: result.response.message,
        };
    } else {
        return {
            success: false,
            message: 'Ticket not entered, please try again.',
        };
    }
};
